/**
The main entry point for Homepage.
Referenced by index.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import Storage from '@outdoor-voices/ui/dist/utils/Storage';
import { Provider } from 'urql';
import { COOKIES } from './config/constants';
import { retailHomePageView } from './utils/retail';
import graphqlClient from './utils/graphqlClient';
import Homepage from './apps/homepage/Homepage';
import { jsx as _jsx } from "react/jsx-runtime";

var initHomepage = function initHomepage() {
  // OVU
  var storage = new Storage();
  var fromOVUCreate = JSON.parse(storage.get(COOKIES.OVU_CREATE));
  storage.remove(COOKIES.OVU_CREATE);

  if (fromOVUCreate) {
    window.location.assign('/account');
    return false;
  }

  var urlParams = new URLSearchParams(window.location.search);
  var client = graphqlClient(urlParams);
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    value: client,
    children: /*#__PURE__*/_jsx(Homepage, {})
  }), document.getElementById('homepage'));
  return true;
};

initHomepage();
retailHomePageView();